import { decamelizeKeys } from 'humps';

import { pilot } from '~/services/serviceInstances';

type UpdateClientAdminProps = {
  clientId: string;
  inactiveTimeoutInSeconds?: number;
  sessionTimeoutInSeconds?: number;
  documentDeleteReasonRequired?: boolean;
  disableDocTagging?: boolean;
};
export const updateClientAdmin = ({
  clientId,
  inactiveTimeoutInSeconds,
  sessionTimeoutInSeconds,
  documentDeleteReasonRequired,
  disableDocTagging,
}: UpdateClientAdminProps) =>
  pilot.put(
    `client/${clientId}/user-admin/`,
    decamelizeKeys({
      disableDocTagging,
      documentDeleteReasonRequired,
      inactiveTimeoutInSeconds,
      sessionTimeoutInSeconds,
    }),
  );
